import axios from 'axios';

export const fetchVariableConfig = async ( variableName ) => {
    
    if (variableName !== '') {
    const url = './config.json'
    const response = await axios.get(url);
    const data = response.data.variables;
    return(data[variableName]);
    }
    else {
        return ''
    }
  };